<template>
  <div class="relative icon-select-input-wrapper relative">
    <icon v-if="value" :icon="value ? value : false" class="icon-demo"></icon>
    <form-input
      v-bind="safeAttrs"
      v-model="value"
      item-component="Select2IconSelectItem"
      :label="false"
      type="select2"
      :translate-list="true"
      :list="internalIconList"
      :wrapper-margins="false"
      :auto-input-styleing="false">
    </form-input>
  </div>
</template>

<script>
import SimpleInputMixin from "@/client/extensions/mixins/baseComponents/form/controls/input/simpleInput.js";
import FormInputMixin from "@/client/extensions/mixins/baseComponents/form/controls/formInput";

let allIconsGlobal = {};
let appName = process.env.VUE_APP_APPLICATION_NAME;
let defaultIconSet = config.style.defaultIconSet;
let context = require.context("@/", true, /\/static\/icons\/.*\/.*\.*.svg/);
let getIconObject = (key) => {
  let fullPath = key;
  let split = key.split("/");
  let set = split[split.length - 2];
  let iconName = split[split.length - 1].split(".")[0];
  let uniqueKey;

  uniqueKey = set + "-" + iconName;

  return {
    uniqueKey: uniqueKey,
    icon: iconName,
    set: set,
    path: fullPath,
  };
};

let addIconObject = (key) => {
  let obj = getIconObject(key);
  allIconsGlobal[obj.uniqueKey] = obj;
};

context.keys().forEach((key) => {
  addIconObject(key);
});

context = require.context(
  "@/client/applications/",
  true,
  /\/static\/icons\/.*\/.*\.*.svg/
);
context.keys().forEach((key) => {
  if (key.startsWith(`./${appName}/`)) {
    addIconObject(key);
  }
});

export default {
  mixins: [SimpleInputMixin, FormInputMixin],

  props: {
    translateList: {
      type: Boolean,
    },
  },
  data() {
    return {
      list: [
        { value: "bg", label: "bg" },
        { value: "lead", label: "lead" },
      ],
    };
  },
  computed: {
    value: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
    iconList() {
      function leftToInlineEnd(inputString) {
        return inputString.replace(/(left)(?![\s\S]*left)/, "inline-end");
      }

      function leftToInlineStart(inputString) {
        return inputString.replace(/(left)(?![\s\S]*left)/, "inline-start");
      }

      function rightToInlineEnd(inputString) {
        return inputString.replace(/(right)(?![\s\S]*right)/, "inline-end");
      }

      function rightToInlineStart(inputString) {
        return inputString.replace(/(right)(?![\s\S]*right)/, "inline-start");
      }

      let result = [];
      let isRtl = this.isLanguageRtl();
      for (const icon of Object.values(allIconsGlobal)) {
        let iconName = icon.icon;

        if (!iconName.endsWith("left") && !iconName.endsWith("right")) {
          result.push(iconName);
        }

        // is directional icon
        if (isRtl && iconName.endsWith("left")) {
          result.push(leftToInlineEnd(iconName));
          continue;
        }

        if (isRtl && iconName.endsWith("right")) {
          result.push(rightToInlineStart(iconName));
          continue;
        }

        if (!isRtl && iconName.endsWith("left")) {
          result.push(leftToInlineStart(iconName));
          continue;
        }

        if (!isRtl && iconName.endsWith("right")) {
          // ltr right -> inlineEnd
          result.push(rightToInlineEnd(iconName));
          continue;
        }
      }

      result = result.sort();
      return result;
    },
    internalIconList() {
      let icons = this.iconList;
      let optionList = icons.map((icon) => {
        return {
          value: icon,
          label: icon,
          icon: icon,
        };
      });

      return optionList;
    },
    safeAttrs() {
      let base = { ...this.$attrs };
      delete base.class;
      delete base.validationMessage;
      return base;
    },
  },
};
</script>

<style lang="scss" scoped>
.icon-select-input-wrapper :deep(.field__element) {
  padding-inline-start: 3.5em !important;
}
.icon-demo {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  margin-inline-start: 2em;
  height: 1.7em;
  width: 1.7em;
  border: 1px solid var(--c-gray-2);
  z-index: 2;
  transition: background-color 150ms ease;
}
</style>
